import React from 'react';
import { Link } from 'react-router-dom';
import MetaData from './MetaData';
import { FaTimesCircle } from 'react-icons/fa';

const Canceled = () => (
  <>
    <MetaData title="Booking Canceled" />
    <div className="row wrapper" style={{ minHeight: '70vh' }}>
      <div className="col-10 col-lg-6 text-center">
        <div className="card p-5">
          <FaTimesCircle size={80} color="var(--color-danger)" className="mb-4" />
          <h2 className="text-danger mb-3">Booking Canceled</h2>
          <p className="text-muted mb-4">Your booking has been successfully canceled.</p>
          <Link to="/" className="btn btn-primary py-2 px-4 fw-semibold">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default Canceled;